import { Checkout } from '@app/pages/checkout-app/checkout-layout/main/components/checkout/react/models/Checkout';
import { CheckoutStatus } from '../models/CheckoutStatus';

export const moveLiveCheckoutToTopOfTheList = (checkouts: Checkout[], runningAbTestCheckoutIds: number[]) => {
  checkouts.sort((a, b) => {
    const aStatus = getCheckoutStatus(a, runningAbTestCheckoutIds);
    const bStatus = getCheckoutStatus(b, runningAbTestCheckoutIds);
    if (aStatus === bStatus) {
      return a.id - b.id;
    }

    const checkoutStatusesOrder = Object.values(CheckoutStatus);

    return checkoutStatusesOrder.indexOf(aStatus) - checkoutStatusesOrder.indexOf(bStatus);
  });
};

export const getCheckoutStatus = (checkout: Checkout, runningAbTestCheckoutIds: number[]): CheckoutStatus => {
  const isCheckoutSegmented = checkout.checkoutShippingMethodGroupSegments?.length > 0 || false;
  const hasRunningAbTest = runningAbTestCheckoutIds.includes(checkout.id);
  if (checkout.isLive && hasRunningAbTest) {
    return isCheckoutSegmented ? CheckoutStatus.LiveAbTestSegmented : CheckoutStatus.DefaultAndAbTestRunning;
  }

  if (hasRunningAbTest) {
    return isCheckoutSegmented ? CheckoutStatus.AbTestSegmented : CheckoutStatus.AbTest;
  }

  if (!hasRunningAbTest && checkout.isLive) {
    return isCheckoutSegmented ? CheckoutStatus.LiveSegmented : CheckoutStatus.Default;
  }

  if (!hasRunningAbTest && !checkout.isLive) {
    return isCheckoutSegmented ? CheckoutStatus.DisabledSegmented : CheckoutStatus.Disabled;
  }

  return CheckoutStatus.Disabled;
};
